/*
  This file defines a custom redux context. All usages of react-redux should go
  through these hooks so they use our custom context.
  The problem we're solving here is that by using a custom redux context in tasks,
  we don't have to worry about redux hooks conflicting with other redux contexts
*/
import { createContext } from 'react';
import { createStoreHook, createDispatchHook, createSelectorHook } from 'react-redux';

// Export this so we can use it in the Provider for the app
export const TasksReduxContext = /*#__PURE__*/createContext(null);

// Create new redux hooks that use our custom context
export const useStore = createStoreHook(TasksReduxContext);
export const useDispatch = createDispatchHook(TasksReduxContext);
export const useSelector = createSelectorHook(TasksReduxContext);